import { defineFetch } from 'resift';

interface BatchAction {
  type: 'create' | 'destroy';
  id: string; // User Id
  data?: {
    exclude: boolean; // "true" if adding to the exclusion list, "false" if adding to the inclusion list; if none passed, will return both manually excluded and included members
  };
}

const makeUpdateRoleMembers = defineFetch({
  displayName: 'Update Role Members',
  make: (id: string) => ({
    request: (actions: BatchAction[]) => ({ http }) =>
      http({
        method: 'PUT',
        route: `/roles/${id}/members`,
        data: { actions },
      }),
  }),
});

export default makeUpdateRoleMembers;
